import ArrTreeView from '../../../components/common/arr-tree-view/ArrTreeView';
import {TreeViewBaseItem} from '@mui/x-tree-view';
import {ExtendedTreeItemProps} from '../../../shared/interfaces';
import {CustomMenuItem} from '../../../components/common/arr-menu/ArrMenu';

export const treeData: TreeViewBaseItem<ExtendedTreeItemProps>[] = [
  {
    id: '100PARENT_TAG0',
    label: 'Legal Tags',
    name: 'legal_tags',
    fileType: 'folder',
    createdBy: 'admin@example.com',
    createdDate: '2023-10-10T10:00:00Z',
    updatedBy: 'admin@example.com',
    updatedDate: '2023-10-15T12:00:00Z',
    children: [
      {
        id: '101CHILD_TAG1000',
        label: 'Confidential',
        count: '25',
        fieldId: '100PARENT_TAG0',
        parentFolder: 'Legal Tags',
        parentTagName: 'legal_tags',
        displayOrder: 2,
        fileType: 'a',
        children: [
          {
            id: '101CHILD_TAG2000',
            label: 'Confidential',
            count: '25',
            fieldId: '100PARENT_TAG0',
            parentFolder: 'Legal Tags',
            parentTagName: 'legal_tags',
            displayOrder: 2,
            fileType: 'search_private',
          },
          {
            id: '102CHILD_TAG2001',
            label: 'Public',
            count: '12',
            fieldId: '100PARENT_TAG0',
            parentFolder: 'Legal Tags',
            parentTagName: 'legal_tags',
            displayOrder: 1,
            fileType: 'folder',
            children: [
              {
                id: '101CHILD_TAG3000',
                label: 'Confidential',
                count: '25',
                fieldId: '100PARENT_TAG0',
                parentFolder: 'Legal Tags',
                parentTagName: 'legal_tags',
                displayOrder: 2,
                fileType: 'file',
              },
              {
                id: '102CHILD_TAG3001',
                label: 'Public',
                count: '12',
                fieldId: '100PARENT_TAG0',
                parentFolder: 'Legal Tags',
                parentTagName: 'legal_tags',
                displayOrder: 1,
                fileType: 'loads_not_indexed',
              },
            ],
          },
        ],
      },
      {
        id: '102CHILD_TAG1001',
        label: 'Public',
        count: '12',
        fieldId: '100PARENT_TAG0',
        parentFolder: 'Legal Tags',
        parentTagName: 'legal_tags',
        displayOrder: 1,
        fileType: 'file',
        isScopeSelected: true,
      },
    ],
  },
  {
    id: '200PARENT_TAG1',
    label: 'Departments',
    name: 'department_tags',
    fileType: 'folder',
    createdBy: 'manager@example.com',
    createdDate: '2023-09-01T08:00:00Z',
    updatedBy: 'manager@example.com',
    updatedDate: '2023-09-10T09:00:00Z',
    children: [
      {
        id: '201CHILD_TAG2000',
        label: 'HR',
        count: '8',
        fieldId: '200PARENT_TAG1',
        parentFolder: 'Departments',
        parentTagName: 'department_tags',
        displayOrder: 3,
        fileType: 'file',
        showProgress: true,
        progressPercentage: 50,
      },
      {
        id: '202CHILD_TAG2001',
        label: 'Engineering',
        count: '18',
        fieldId: '200PARENT_TAG1',
        parentFolder: 'Departments',
        parentTagName: 'department_tags',
        displayOrder: 2,
        fileType: 'file',
        disabled: true,
      },
      {
        id: '203CHILD_TAG2002',
        label: 'check default',
        count: '14',
        fieldId: '200PARENT_TAG1',
        parentFolder: 'Departments',
        parentTagName: 'department_tags',
        displayOrder: 1,
        fileType: 'file',
        showMoreOptions: true,
        showActionButtonWithLabel: true,
        actionButtonName: 'button',
        actionButtonLabel: 'button label',
      },
      {
        id: '202CHILD_TAG2801',
        label: 'Engineering',
        count: '18',
        fieldId: '200PARENT_TAG1',
        parentFolder: 'Departments',
        parentTagName: 'department_tags',
        displayOrder: 2,
        fileType: 'loads_not_indexed',
        notYetIndexed: 110,
        added: true,
      },
    ],
  },
];

const TreeViewDemo: React.FC = () => {
  const userDetailsMoreMenu: CustomMenuItem[] = [
    {label: 'Edit', id: 'edit'},
    {label: 'Delete', id: 'delete'},
  ];

  const handleSelected = (values: string[] | null) => {
    console.log('selected iddd', values);
  };

  return (
    <div style={{display: 'flex', backgroundColor: '#182231', gap: '8px'}}>
      <div style={{width: '500px', height: '700px'}}>
        Multi select with checkbox
        <ArrTreeView
          itemsList={treeData}
          selectedItem={''}
          handleNoResultMessage={'hi'}
          allowGlobalSelect={false}
          treeSelectedItems={[]}
          // multipleSelection={true}
          isShowCountLabel={true}
          //  isShowCheckbox={true}
          showActions={true}
          MoreMenuOptions={userDetailsMoreMenu}
          customContentHeight={56}
          setSelectedItem={handleSelected}
        />
      </div>

      <div style={{width: '300px', height: '500px'}}>
        Multi select with no checkbox
        <ArrTreeView
          itemsList={treeData}
          selectedItem={''}
          handleNoResultMessage={'hi'}
          allowGlobalSelect={false}
          treeSelectedItems={[]}
          multipleSelection={true}
          isShowCountLabel={true}
          isShowCheckbox={false}
          setSelectedItem={handleSelected}
        />
      </div>
      <div style={{width: '300px', height: '500px'}}>
        Single select
        <ArrTreeView
          setSelectedItem={handleSelected}
          itemsList={treeData}
          selectedItem={''}
          handleNoResultMessage={'hi'}
          allowGlobalSelect={false}
          treeSelectedItems={[]}
          multipleSelection={false}
          isShowCountLabel={true}
          isShowCheckbox={false}
        />
      </div>
    </div>
  );
};

export default TreeViewDemo;
